import React from "react";

import Editor from './EditorArticle'
import EditorWrapper from '../../EditorWrapper'

import Top from "../../../redesign/components/TextOnPicture";
import EmptyArticle from "../../common/EmptyArticle";

const BTextOnPicture = props => {
  var article = EmptyArticle();
  const settings = props.settings;
  const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

  article.title = settings.title_normal;
  article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
  article.url = settings.link;
  article.partner = settings.partner;
  article.label = settings.label;
  article.icon = settings.icon;
  article.player = settings.player;
  article.iconHotNews = (parseInt(settings.iconHotNews) === 1);
  article.stats = (settings.stats ? settings.stats : { shares: '0', comments: '0' });
  article.category = {
    ...(settings?.post_category ?? {}),
    name: (settings.category ? settings.category : settings.label)
  };
  article.categoryColor = settings.categoryColor;
  // linki dodatkowe
  settings.show_links = (settings.show_links ? settings.show_links : 'off');
  article.show_links = settings.show_links;
  article.links = settings.links;

  // partner
  settings.show_partner_logo = true;
  article.partner_logo = settings.partner_logo;

  if (settings.embed) {
    article.embed = settings.embed
  }


  // props.onRegisterBox(props.blockId, props.id, 'title_normal')
  return (
    <div className={props.classes} {...props.events} data-tb-region-item>
      <EditorWrapper {...props} editor={Editor} />
      <Top
        blockType={props.block_type}
        article={article}
        size={props.size}
        imageHeight={props.imageHeight}
        preserveImageRatio={props.preserveImageRatio}
        aspectRatio={props.aspectRatio}
        media={settings.media}
        style={settings.background}
        isOneSuper={props.isOneSuper}
        fetchpriority={props.fetchpriority}
        disablePreload={settings.disablePreload}
      />
    </div>
  );
};

export default BTextOnPicture;
